import Rhythm from './Rhythm.js';

function round3(num) {
  return Math.round( ( num + Number.EPSILON ) * 1000 ) / 1000;
}

function inferRhythm(events, delay) {
  const eventDetails = events.map(event => [event.time - delay, event.hand]);
  eventDetails.sort((a, b) => a[0] - b[0] || a[1] - b[1]);
  // If exactly one event per beat and alternating hands, it's async RH/LH depending on start hand
  // If exactly one throw per hand every second beat, it's sync standard
  // If exactly one throw per hand every beat, it's sync dense
  if (eventDetails.every((event, i) => i % 2 == event[1] && event[0] == i)) {
    return Rhythm.ASYNC_LH;
  } else if (eventDetails.every((event, i) => i % 2 == 1 - event[1] && event[0] == i)) {
    return Rhythm.ASYNC_RH;
  } else if (eventDetails.every((event, i) => event[0] == i - (i%2) && event[1] == i%2)) {
    return Rhythm.SYNC_STANDARD;
  } else if (eventDetails.every((event, i) => event[0] == Math.floor(i/2) && event[1] == i%2)) {
    return Rhythm.SYNC_DENSE;
  }
  return Rhythm.CUSTOM;
}

export default class Juggler {
  constructor(config) {
    this.id = config.id;
    this.name = config.name;
    this.rhythm = config.rhythm;
    this.delay = config.delay;
    this.position = config.position;
    this.lookAt = config.lookAt;
  }

  nameOrDefault() {
    return this.name || "Juggler " + (this.id + 1);
  }

  static fromJIF(id, jugglerJif, events) {
    const jugglerEvents = events.filter(event => event.juggler === id);
    const delay = Math.min(...jugglerEvents.map(event => event.time));
    const rhythm = inferRhythm(jugglerEvents, delay);
    return new Juggler({
      id: id,
      rhythm: rhythm,
      delay: delay,
      name: jugglerJif.name,
      position: jugglerJif.position,
      lookAt: jugglerJif.lookAt,
    });
  }

  toJIF(numJugglers) {
    // TODO: take jugglerlayout into account as a param
    if (this.position === undefined) {
      const radius = numJugglers === 1 ? 0 : 1.5;
      const angle = 2 * Math.PI * this.id / numJugglers;
      this.position = [round3(radius * Math.cos(angle)), 0, round3(radius * Math.sin(angle))];
    }
    if (this.lookAt === undefined) {
      this.lookAt = [0, 0, numJugglers === 1 ? 1 : 0];
    }
    return {
      name: this.name,
      position: this.position,
      lookAt: this.lookAt,
    };
  }

  jifLimbs() {
    return [
      { juggler: this.id, type: "right hand" },
      { juggler: this.id, type: "left hand" },
    ];
  }
}
